module.exports = __webpack_public_path__ + "images/01c83cb66a7b6473591fd82f06e52f58.png";